<template>
    <div class="cs-autoWorkflowPaymentType">
        <img v-if="!!imgSrc" :src="imgSrc">
    </div>
</template>

<style lang="scss" scoped>
.cs-autoWorkflowPaymentType{
    img{
        width: 20px;
    }
}
</style>

<script>
import { getPaymentImgList } from "@/config/mUtils.js";
export default {
    props: {
        data: {},
    },
    data() {
        return {
            paymentImgList: {},
            paymentTypeId: 0,
            paymentTypeName: 0,
            imgSrc: ""
        };
    },
    components: {},
    created() {
        this.paymentImgList = getPaymentImgList();
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.paymentTypeId = this.data.PaymentTypeId;
                this.paymentTypeName = this.data.PaymentTypeName;
                this.imgSrc = this.getImgSrc();
            }
        },
        getImgSrc() {
            if (this.paymentImgList){
                return this.paymentImgList[this.paymentTypeName];
            }
            return "";
        },
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/autoWorkflowPaymentTypeCell.vue